import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
const SvgCodepen = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="m12 2 10 6.5v7L12 22 2 15.5v-7zM12 22v-6.5" />;
    t1 = <path d="m22 8.5-10 7-10-7" />;
    t2 = <path d="m2 15.5 10-7 10 7M12 2v6.5" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default SvgCodepen;